import { Button, SectionContent } from "components";

export default function UpdatePhoneComponent({
  isValid,
  values,
  setFieldValue,
  phoneNumber,
  setReconfirm,
}) {
  // check if the values contain all true values
  const valid = Object.values(values).every(Boolean);
  return isValid &&
    valid &&
    isChanged(values.updatePhoneNumber, phoneNumber) ? (
    <div className="my-4">
      <SectionContent>
        <div className="p-2 rounded bg-box shadow-card-box dark:bg-gray-800">
          <div className="pb-2 mb-6 font-semibold border-b dark:border-gray-500 dark:text-white">
            Reconfirm Update Action
          </div>
          <div className="dark:text-white">
            <div className="flex flex-col items-start gap-1">
              Kindly reconfirm that you want to update this phone number{" "}
              <span>
                from {phoneNumber} to {values.updatePhoneNumber}
              </span>
            </div>
            <div className="flex flex-row items-center mt-4 space-x-2">
              <Button
                gradient
                label="Yes"
                handleClick={() => setReconfirm(true)}
              />
              <Button
                color="default"
                label="No"
                handleClick={() =>
                  setFieldValue("updatePhoneNumber", phoneNumber)
                }
              />
            </div>
          </div>
        </div>
      </SectionContent>
    </div>
  ) : null;
}

function isChanged(oldPhone, newPhone) {
  return oldPhone !== newPhone;
}
